
import './App.css';
import {BrowserRouter as Router, Routes as Switch, Route, useLocation} from "react-router-dom";

import {Lsd, FoodMenu, ShaqabMenu, LtbMenu, ChariotMenu, AfterNoonTeaMenu, ErgonMenu, LeBleuMenu, LeBleuMenuEv, LsdAbout, LsdContact, LsdIntroPage, LeBleuMenuNew, Turquoise, Analytics, Maintenance} from "./pages";
import {TestAdmin, UpdateItem, EditItem, AdminLogin, AllRestaurantsLogin, RestaurantsDashboard, RestaurantsList } from "./adminPages";
import { ScrollToTop, SecureRoute} from './components';
import { AnimatePresence } from 'framer-motion';
import RequireAuth from './components/RequireAuth';
import {BaronMenuNew, BaronMenuNewAr} from "./pages/BaronMenu/"
import {HabraMenuNewEn, HabraMenuNewAr} from "./pages/HabraMenuNew";
import { WcsMenuAspireEn, WcsMenuAspireAr, WcsMenuAspireNewEn, WcsMenuAspireNewAr } from './pages/wcsAspireShaqabMenu';
import {WcsMenuWestBayEn, WcsMenuWestBayAr} from "./pages/wcsWestbayMenu";
import {WcsMenuWestWalkEn, WcsMenuWestWalkAr} from "./pages/wcsWestWalkMenu";
import {WcsEventMenuEn, WcsEventMenuAr} from "./pages/wcsEventMenu";
import { FiveAmMenuAr, FiveAmMenuEn } from './pages/fiveAamMenu';
import {LunchRoomMenuEn, LunchRoomMenuBrunchEn, LunchRoomMenuLunchEn, CoverPageLunch} from './pages/LunchroomMenu';
import SekKhalifaMenu from './pages/SekKhalifaMenu';


function App() {

  const location = useLocation();
  return (
    // <div className="App">
      <div className="layout">
          <ScrollToTop/>
          <AnimatePresence>
            <Switch location = {location} key = {location.pathname}>

                {/* LDS CORE PAGES */}
                <Route exact path = "/" element = {<LsdIntroPage/>}/>
                <Route  path = "/home" element = {<Lsd/>}/>
                <Route path = "/about" element = {<LsdAbout/>}/>
                <Route path = "/contact-us" element = {<LsdContact/>}/>

                {/* SHAWARMA AL KHEBBEZ LINKS */}
                {/* <Route path = "/restaurants/menus/shawarma-el-khebbez" element = {<FoodMenu/>}/>
                <Route path = "/restaurants/menus/shawarma-el-khebbez/shaqab" element = {<ShaqabMenu/>}/>
                <Route path = "/restaurants/menus/shawarma-el-khebbez/khalifa" element = {<SekKhalifaMenu/>}/> */}

                {/* WCS LINKS */}
                {/* <Route path = "/restaurants/menus/white-coffee-spot-aspire" element = {<WcsMenuAspireNewEn/>}/>
                <Route path = "restaurants/menus/white-coffee-spot-aspire-ar" element = {<WcsMenuAspireNewAr/>}/>
                <Route path = "/restaurants/menus/white-coffee-spot-westbay" element = {<WcsMenuWestBayEn/>}/>
                <Route path = "restaurants/menus/white-coffee-spot-westbay-ar" element = {<WcsMenuWestBayAr/>}/>
                <Route path = "restaurants/menus/white-coffee-spot-westwalk" element = {<WcsMenuWestWalkEn/>}/>
                <Route path = "restaurants/menus/white-coffee-spot-westwalk-ar" element = {<WcsMenuWestWalkAr/>}/>
                <Route path = "restaurants/menus/white-coffee-spot-event-en" element = {<WcsEventMenuEn/>}/>
                <Route path = "restaurants/menus/white-coffee-spot-event-ar" element = {<WcsEventMenuAr/>}/> */}

                {/* lTB LINK */}
                {/* <Route path = "/restaurants/menus/le-train-bleu" element = {<LtbMenu/>}/> */}
                {/* <Route path = "/restaurants/menus/le-train-bleu/Afternoon-tea" element = {<AfterNoonTeaMenu/>}/> */}

                {/* CHARIOT LINKS -- get rid of requiredRole (its old admin) */}
                {/* <Route path = "/restaurants/menus/chariot" element = {<ChariotMenu/>}/> */}

                {/* ERGON LINK */}
                {/* <Route path = "/restaurants/menus/ergon" element = {<ErgonMenu/>}/> */}
             
                {/* LE BLEU LINKS */}
                {/* <Route path = "/restaurants/menus/le-bleu-westwalk" element = {<LeBleuMenu/>}/>
                <Route path = "restaurants/menus/le-bleu" element = {<LeBleuMenuNew />}/>
                <Route path = "/restaurants/menus/le-bleu/admin/login" element = {<AdminLogin/>}/> */}
                {/* GET RID OF REQUIRED AUTH ( OLD ADMIN) */}
                {/* <Route element = {<RequireAuth requiredRole = "le-bleu"/>}>
                  <Route path = "/restaurants/menus/le-bleu/admin/update-item" element  = {<UpdateItem/>}/>
                  <Route path = "/restaurants/menus/le-bleu/admin/add-item" element = {<TestAdmin/>}/>
                  <Route path = "/restaurants/menus/le-bleu/admin/edit-item/:id" element = {<EditItem/>}/>
                </Route>
                <Route path = "/restaurants/menus/le-bleu-event" element = {<LeBleuMenuEv/>}/> */}

                {/* BARON LINKS */}
                {/* <Route path = "restaurants/menus/baron" element = {<BaronMenuNew/>}/>
                <Route path = "restaurants/menus/baron-ar" element = {<BaronMenuNewAr/>}/> */}
                {/* <Route path = "restaurants/menus/baron" element = {<Maintenance/>}/> */}

                {/* HABRA LINKS */}
                {/* <Route path = "restaurants/menus/habra" element = {<HabraMenuNewEn/>}/>
                <Route path = "restaurants/menus/habra-ar" element = {<HabraMenuNewAr/>}/> */}

                {/* TURQOISE LINKS */}
                {/* <Route path = "restaurants/menus/turquoise" element = {<Turquoise/>}/> */}

                {/* FIVE AM LINKS */}
                {/* <Route path = "restaurants/menus/five-am" element = {<FiveAmMenuEn/>}/>
                <Route path = "restaurants/menus/five-am-ar" element = {<FiveAmMenuAr/>}/> */}

                {/* LUNCHROOM LINKS */}
                {/* <Route path = "restaurants/menus/lunchroom" element = {<CoverPageLunch/>}/> */}
                {/* <Route path = "restaurants/menus/lunchroom" element = {<LunchRoomMenuEn/>}/> */}
                {/* <Route path = "restaurants/menus/lunchroom/brunch" element = {<LunchRoomMenuBrunchEn/>}/>
                <Route path = "restaurants/menus/lunchroom/lunch" element = {<LunchRoomMenuLunchEn/>}/> */}
               
                {/* ------ RESTAURANTS MANAGEMENT ROUTE -- KEEP SECURE VERY IMPORTANT!! */}
                {/* <Route path = "/restaurants/menus/login" element = {<AdminLogin/>}/> */}
                {/* All restaurants will login using this compoent */}
                {/* <Route path = "/restaurants/menus/admin/login" element = {<AllRestaurantsLogin/>}/> */}
                {/* Routes secured by SecureRoute*/}
                {/* <Route element = {<SecureRoute/>}>
                  <Route path = "/restaurants/menus/admin/restaurants" element = {<RestaurantsList/>}/>
                  <Route path="/restaurants/menus/admin/restaurants/:name" element={<RestaurantsDashboard />}/>
                </Route>    */}
                {/* <Route path = "/sek/test" element = {<Analytics/>}/> */}
            </Switch>
          </AnimatePresence>
      </div>
    // </div>
  );
}

export default App;

